export const HOMEPAGE_WIDGETS_SEARCH = 'HOMEPAGE_WIDGETS_SEARCH';
export const HOMEPAGE_WIDGETS_SAVE = 'HOMEPAGE_WIDGETS_SAVE';
export const HOMEPAGE_WIDGETS_SAVE_SUCCESS = 'HOMEPAGE_WIDGETS_SAVE_SUCCESS';
export const HOMEPAGE_WIDGETS_REMOVE = 'HOMEPAGE_WIDGETS_REMOVE';
export const HOMEPAGE_WIDGETS_LOAD = 'HOMEPAGE_WIDGETS_LOAD';
export const HOMEPAGE_WIDGETS_LOADED = 'HOMEPAGE_WIDGETS_LOADED';
export const HOMEPAGE_WIDGETS_UNLOAD = 'HOMEPAGE_WIDGETS_UNLOAD';
export const HOMEPAGE_WIDGETS_SAVE_STATIC_IMAGES = 'HOMEPAGE_WIDGETS_SAVE_STATIC_IMAGES';
